module.exports = __webpack_public_path__ + "img/nicetohave-product-design-09.0ecc9bf6.jpg";